﻿import {deepEquals, NamedValue} from "@2d-front-monorepo/core";
import {useMemo} from "react";

export function useSelectedItems<TValue>(items: NamedValue<TValue>[], values: TValue[] | undefined): string[] {
	return useMemo(() => {
		if (values == null || values.length === 0) {
			return [];
		}

		const result: string[] = [];
		for (const value of values) {
			const idx = items.findIndex(x => deepEquals(value, x.value));
			if (idx === -1) {
				continue
			}

			result.push(idx.toString());
		}

		return result;

	}, [values, items]);
}
